import React, {useContext, useEffect} from 'react'
import classNames from 'classnames'
import Helmet from 'react-helmet'
import {handleTradeIntegrationErrorResponse, integrations} from 'Src/actions/TradeActions'
import HeaderlessLayout from 'Src/components/Layouts/HeaderlessLayout'
import PlaceholderSpinner from 'Src/components/Spinners/PlaceholderSpinner'
import TradeLogo from 'Src/components/TradePartners/common/TradeLogo'
import {useDealDispatchContext, useDealStateContext} from 'Src/contexts/DealContext'
import {useFrameContext} from 'Src/contexts/FrameContext'
import {NavDispatchContext} from 'Src/contexts/NavContext'
import {IIntegrationData, useFetchTradeIntegration} from 'Src/queries/useFetchDealerships'
import {getIsProduction, transString} from 'Src/utilities/Helpers'
import {TOKEN_STATE} from 'Src/utilities/useToken'

const TradeVehicle = () => {
  const dealDispatch = useDealDispatchContext()
  const dealState = useDealStateContext()
  const {loaded} = dealState
  const {data, error} = useFetchTradeIntegration()
  const pageHeading = transString('trade_int.document_title')
  const TradeFlow = integrations?.[data?.integrationName] ?? PlaceholderSpinner
  const navDispatch = useContext(NavDispatchContext)
  const {tokenState} = useFrameContext()
  const isNotProduction = !getIsProduction()

  useEffect(() => {
    if (!loaded) {
      return
    }

    dealDispatch({
      type: 'update',
      payload: {
        ...{
          loading: false,
          isUpdating: false,
        },
      },
    })
  }, [loaded])

  useEffect(() => {
    if (error) {
      handleTradeIntegrationErrorResponse(error)
    }
  }, [error])

  const handlePageClose = () => {
    navDispatch({type: 'closeSlideOut'})
  }

  if (tokenState === TOKEN_STATE.LOADING) {
    return <PlaceholderSpinner className={classNames({'tw-bg-fuchsia-500': isNotProduction})} />
  }

  if (tokenState === TOKEN_STATE.AUTHENTICATED && !loaded) {
    return <PlaceholderSpinner className={classNames({'tw-bg-lime-500': isNotProduction})} />
  }

  return (
    <>
      <Helmet>
        <title>{pageHeading}</title>
      </Helmet>
      <HeaderlessLayout onClose={handlePageClose}>
        <div className="tw-mb-6 empty:tw-hidden">
          <TradeLogo integration={(data as IIntegrationData['data'])?.integrationName} />
        </div>
        <TradeFlow />
      </HeaderlessLayout>
    </>
  )
}

export default TradeVehicle
